import React from 'react';
import {
  Button,
  Flex,
  Heading,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import {
  LoadingScreen,
  useAuthActions,
} from '@texas-education-exchange/edx-portal-shared';
import { setLoggedInUser } from '../slices/authSlice';
import { destroyToken } from '../slices/authentication.slice';
import { useExchangeConfiguration } from '../hooks/configuration.hooks';

const NotAuthorized = ({ errorMessage = '' }) => {
  const { handleLogOut } = useAuthActions();
  const configuration = useExchangeConfiguration();
  const NUMBER_OF_RELOAD_ATTEMPTS = configuration.app.stalledLoginAllowedNumOfRetries;
  const WAIT_TIME_BEFORE_RELOAD_SEC = configuration.app.stalledLoginTimeoutSeconds;
  const WAIT_TIME_BEFORE_RELOAD_MS = WAIT_TIME_BEFORE_RELOAD_SEC * 1000;
  const RELOAD_ATTEMPTS_PARAM = 'reloadAttempts';
  const PARSE_INT_RADIX_DECIMAL = 10;
  const RELOAD_MESSAGE = configuration.app.stalledLoginMessage;
  const UNAUTHORIZED_ERROR_MESSAGE = 'user is not authorized to use the community';

  const dispatch = useDispatch();
  const errorMessageContent = errorMessage?.toLowerCase() ?? '';
  const hasUnauthorizedError = errorMessageContent.includes(UNAUTHORIZED_ERROR_MESSAGE);

  const getReloadAttemptsParam = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const reloadAttemptsParam = urlParams.get(RELOAD_ATTEMPTS_PARAM);
    const hasReloadAttempts = reloadAttemptsParam && reloadAttemptsParam.length > 0;

    return hasReloadAttempts ? parseInt(reloadAttemptsParam, PARSE_INT_RADIX_DECIMAL) : 0;
  };

  const reloadAttempts = getReloadAttemptsParam();
  const reloadBasedOnNumOfAttempts = reloadAttempts < NUMBER_OF_RELOAD_ATTEMPTS;
  const onLogout = async () => {
    dispatch(setLoggedInUser({}));
    dispatch(destroyToken());
    await handleLogOut();
  };

  const reloadPage = () => {
    const currentUrl = new URL(window.location.href);
    const baseUrl = currentUrl.origin + currentUrl.pathname;
    const reloadUrl = new URL(baseUrl);
    reloadUrl.searchParams.set(RELOAD_ATTEMPTS_PARAM, reloadAttempts + 1);
    window.location.href = reloadUrl.toString();
  };

  setTimeout(() => {
    const stillOnCallbackPage = document.body.textContent.includes(RELOAD_MESSAGE);
    if (stillOnCallbackPage && reloadBasedOnNumOfAttempts && !hasUnauthorizedError) {
      reloadPage();
    }
  }, WAIT_TIME_BEFORE_RELOAD_MS);

  return (
    hasUnauthorizedError ? (
      <Flex
        flexDirection="column"
        maxWidth="780px"
        textAlign="left"
        justifyContent="center"
        gap={4}
        margin="auto"
        mt="15rem"
      >
        <Heading as="h1" color="blue.800" textAlign="center">
          It looks like you’re having issues accessing The Exchange.
          Please contact your district’s Technical Administrator.
        </Heading>
        <Button
          onClick={onLogout}
        >
          Log Out
        </Button>
      </Flex>
    ) : (
      reloadBasedOnNumOfAttempts ? (
        <LoadingScreen state={RELOAD_MESSAGE} loading />
      ) : (
        <Flex
          flexDirection="column"
          maxWidth="780px"
          textAlign="left"
          justifyContent="center"
          gap={4}
          margin="auto"
          mt="15rem"
        >
          <Heading as="h1" color="blue.800" textAlign="center">
            Please refresh your browser when logging in the first time. We are
            working on a fix. Thank you for your patience!
          </Heading>
          <Button
            onClick={onLogout}
          >
            Log Out
          </Button>
        </Flex>
      )
    )
  );
};
export default NotAuthorized;
